var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"d-flex align-center",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":item.href}},[_c('div',{staticStyle:{"padding":"0px"},domProps:{"innerHTML":_vm._s(item.text)}})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }